import { Component, OnInit, ViewChild } from '@angular/core';
// import { ApiService } from '../shared/api/index';
import { Sidebar } from 'primeng/sidebar';
import { BreakpointObserver } from '@angular/cdk/layout';
import { MatSidenav } from '@angular/material/sidenav';
import { Router, NavigationEnd } from '@angular/router';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { initConsoleCollector } from './common/console-collector';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../environments/environment';
import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
(window as any).getConsoleLogs = initConsoleCollector();
// Client pages
import { PagesServiceDemo } from 'src/app/pages/clients/demo/demo.component';
import { RefreshIcon } from 'primeng/icons/refresh';

import { AuthService } from 'src/app/services/auth.service';
import { UserService } from './services/users.service';

// Language
import { appDictionary } from 'src/app/models/imadata/app-diccionary';
import { LanguageService } from 'src/app/services/language.service';
import { Subscription } from 'rxjs';

// Bug report
import { BugReportsService } from './services/bug_reports.service';
import { PermissionsService } from './services/permissions.service';
import { BugReportPayload } from './models/imadata/BugReportPayloadInterface';
import { resolveCompanySectionOrder } from './common/company-section-order';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [
    // Animaciones para la barra lateral y desvanecimiento
    trigger('sidebarAnimation', [
      state(
        'open',
        style({
          width: '100%',
          'max-width': '350px',
          opacity: 1,
          overflow: 'hidden',
        }),
      ),
      state(
        'closed',
        style({
          width: '75px',
          'max-width': '75px',
          opacity: 1,
          overflow: 'hidden',
        }),
      ),
      transition('open <=> closed', [animate('0.3s')]),
    ]),
    trigger('desvanecer', [
      state('open', style({ opacity: 1 })),
      state('closed', style({ opacity: 0 })),
      transition('open <=> closed', [animate('0.5s')]),
    ]),
  ],
})
export class AppComponent implements OnInit {
  /**
   * Referencia a la barra lateral de PrimeNG.
   */
  @ViewChild('sidebarRef') sidebarRef!: Sidebar;

  /**
   * Referencia a la barra lateral de Angular Material.
   */
  @ViewChild(MatSidenav)
  sidenav!: MatSidenav;

  // ===========================
  // === ATRIBUTOS PRINCIPALES ==
  // ===========================

  /**
   * Idioma actual seleccionado.
   */
  currentLanguage: string;

  /**
   * Diccionario de traducciones.
   */
  dict: any;

  /**
   * Suscripción al observable de cambio de idioma.
   */
  languageSubscription: Subscription;

  /**
   * Controla la visibilidad de la barra lateral.
   */
  sidebarVisible: boolean = false;

  /**
   * Indica si la barra lateral está abierta.
   */
  sidebarOpened = false;

  /**
   * Indica si la aplicación está en estado de carga.
   */
  loading: boolean = true;

  /**
   * Indica si el usuario está autenticado.
   */
  loggedIn: boolean = false;

  /**
   * Información del usuario actual.
   */
  me: any;

  /**
   * Lista de compañías asociadas al usuario.
   */
  companies: any;

  /**
   * Indica si el usuario tiene acceso a múltiples compañías.
   */
  multiplesCompanies: boolean = false;

  /**
   * Páginas disponibles para el usuario.
   */
  Pages: any;

  /**
   * Nombre de la página actual.
   */
  actualPageName: any = '';

  /**
   * Nombre del usuario.
   */
  userName!: string;

  /**
   * Secciones del cliente (menú lateral).
   */
  clientSections: any;

  /**
   * Payload para el reporte de errores.
   */
  bugReportPayload: BugReportPayload = {
    title: '',
    description: '',
    data: '',
    screenshots: [],
  };

  /**
   * Controla la visibilidad del modal de reporte de errores.
   */
  errorReportModalVisible = false;

  /**
   * Descripción adicional del error proporcionada por el usuario.
   */
  errorDescription = '';

  /**
   * Lista de idiomas disponibles para la aplicación.
   */
  countries = [
    { name: 'Español', code: 'es' },
    { name: 'English', code: 'us' },
  ];

  /**
   * País/idioma seleccionado actualmente.
   */
  selectedCountry: any | undefined;

  /**
   * Título de la aplicación.
   */
  title = 'imadata_front';

  // ===========================
  // === MÉTODOS DEL COMPONENTE ==
  // ===========================

  /**
   * Constructor: inicializa servicios y suscripciones.
   */
  constructor(
    private pagesService: PagesServiceDemo,
    private observer: BreakpointObserver,
    private authService: AuthService,
    public userService: UserService,
    private router: Router,
    private languageService: LanguageService,
    public dialogService: DialogService,
    public dynamicDialogRef: DynamicDialogRef,
    private messageService: MessageService,
    private bugReportsService: BugReportsService,
    private permissionsService: PermissionsService,
    protected http: HttpClient,
  ) {
    // Suscripción al estado de autenticación
    this.authService.loginStatus$.subscribe((loggedIn) => {
      this.loggedIn = loggedIn;
    });
    // Inicializa idioma y diccionario
    this.currentLanguage = this.languageService.getLanguage();
    this.dict = appDictionary;
  }

  /**
   * ngOnInit: inicializa la app, carga usuario, botones y gestiona el idioma.
   */
  async ngOnInit() {
    let publicPages = ['/login', '/public'];
    this.loading = true;
    this.authService.loginStatus$.subscribe((loggedIn) => {
      this.loggedIn = loggedIn;
    });

    if (publicPages.includes(this.router.url)) {
      this.loading = false;
    } else {
      this.languageSubscription = this.languageService.language$.subscribe((language: string) => {
        this.currentLanguage = language;
        this.selectedCountry = this.countries.find(
          (country) => country.code === this.currentLanguage,
        );
        this.dict = appDictionary;
        this.updateButtons();
      });
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.updateButtons();
        }
      });
      await Promise.all([this.getMe(), this.updateButtons()]);
    }
    this.loading = false;
  }
  /**
   * Cambia el idioma de la aplicación.
   * @param event Evento de selección de idioma.
   */
  changeLanguage(event: any) {
    const language = event.value.code;
    this.languageService.setLanguage(language);
  }
  /**
   * Actualiza los botones y secciones del sidebar según el usuario y la página actual.
   */
  updateButtons() {
    let actualUrl = this.router.url;
    this.loading = true;
    try {
      this.userService.me().subscribe(
        (response) => {
          this.me = response;
          this.companies = this.me.companies;
          this.multiplesCompanies = this.companies.length > 1 ? true : false;
          this.companies.forEach((company: any) => {
            company.pages = resolveCompanySectionOrder(company, company.pages);
          });
          if (this.me.companies.length == 1) {
            this.clientSections = this.companies[0].pages;
            this.clientSections.forEach((element: any) => {
              try {
                element.nombre = this.dict[element.nombre]()[this.currentLanguage];
              } catch (error) {
                // Sin traduccion en el diccionario se conserva el nombre que ya
                // trae el elemento; solo las paginas de reportes se renombran.
                if (element.url.includes('/reportes/')) {
                  element.nombre = 'Reportes';
                }
              }
              if (actualUrl == element.url) {
                element['active'] = true;
                this.actualPageName =
                  element.nombre.toLowerCase() != 'home' && element.nombre.toLowerCase() != 'inicio'
                    ? element.nombre
                    : '';
              } else {
                element['active'] = false;
              }
            });
          }
          this.companies.forEach((company: any) => {
            company.pages.forEach((element: any) => {
              try {
                element.nombre = this.dict[element.nombre]()[this.currentLanguage];
              } catch (error) {
                // Sin traduccion en el diccionario se conserva el nombre que ya
                // trae el elemento; solo las paginas de reportes se renombran.
                if (element.url.includes('/reportes/')) {
                  element.nombre = 'Reportes';
                }
              }
              if (actualUrl == element.url) {
                element['active'] = true;
                this.actualPageName =
                  element.nombre.toLowerCase() != 'home' && element.nombre.toLowerCase() != 'inicio'
                    ? element.nombre
                    : '';
              } else {
                element['active'] = false;
              }
            });
            company.pages = company.pages.filter(
              (page: any, index: number, self: any[]) =>
                index === self.findIndex((p: any) => p.nombre === page.nombre),
            );
          });
          this.sidebarVisible = false;
          this.loading = false;
        },
        (error) => {
          this.sidebarVisible = false;
          this.loading = false;
        },
      );
    } catch (error) {
      this.loading = false;
    }
  }

  /**
   * Cierra la barra lateral si está en modo 'over'.
   */
  closeToolBar() {
    if (this.sidenav.mode === 'over') {
      this.sidenav.close();
    }
  }

  /**
   * Cambia el modo de la barra lateral entre 'over' y 'side'.
   */
  changeMode() {
    if (this.sidenav.mode !== 'over') {
      this.sidenav.mode = 'over';
      this.sidenav.close();
    } else {
      this.sidenav.mode = 'side';
      this.sidenav.open();
    }
  }

  /**
   * Cambia el modo de la barra lateral tipo "burger".
   * @param mode Modo a aplicar ('open' o 'close').
   */
  changeModeBurger(mode: string) {
    let pageSpace = document.getElementById('pageSpace');
    let headSlidebar = document.getElementById('headSlidebar');
  }
  /**
   * Alterna la visibilidad del menú hamburguesa.
   */
  toggleBurger() {
    let burgerMenu = document.getElementById('burgerMenu');
    let burgerMenu2 = document.getElementById('burgerMenu2');
    if (burgerMenu !== null) {
      if (!burgerMenu.classList.contains('no-hamburgler')) {
        this.sidebarVisible = !this.sidebarVisible;
        burgerMenu.classList.add('no-hamburgler');
        burgerMenu2.classList.add('no-hamburgler');
        this.changeModeBurger('open');
      } else {
        this.sidebarVisible = !this.sidebarVisible;
        burgerMenu.classList.remove('no-hamburgler');
        burgerMenu2.classList.remove('no-hamburgler');
        this.changeModeBurger('close');
      }
    }
  }

  /**
   * Cierra sesión y limpia el estado de la UI.
   */
  logout() {
    this.loggedIn = false;
    this.sidebarOpened = false;
    this.sidebarVisible = false;
    // El mapa de permisos se cachea por sesion; sin limpiarlo, el siguiente
    // usuario que entre sin recargar la SPA heredaria los permisos del anterior.
    this.permissionsService.reset();
    this.authService.logout();
  }

  /**
   * Obtiene la información del usuario actual.
   */
  getMe() {
    this.userService.me().subscribe(
      (response) => {
        this.me = response;
      },
      (error) => {
        this.loading = false;
      },
    );
  }

  /**
   * Muestra el modal para reportar errores.
   */
  showErrorReportModal() {
    this.errorReportModalVisible = true;
    this.bugReportPayload.title = `Error de usuario - ${this.me?.id} - ${new Date().toISOString()}`;
  }

  /**
   * Envía el reporte de error usando BugReportsService.
   * Recopila información del entorno, consola y último error.
   */
  async submitErrorReport() {
    const environmentData = {
      url: window.location.href,
      userAgent: navigator.userAgent,
      platform: navigator.platform,
    };

    const consoleLogs = (window as any).getConsoleLogs();
    const errors = consoleLogs.filter((l: any) => l.type === 'error');
    const warnings = consoleLogs.filter((l: any) => l.type === 'warn');
    const logs = consoleLogs.filter((l: any) => l.type === 'log');

    const dataString = JSON.stringify(
      {
        environment: environmentData,
        consoleLogs: logs,
        consoleErrors: errors,
        warnings: warnings,
      },
      null,
      2,
    );

    const maxDataLength = 4000;
    const safeDataString =
      dataString.length > maxDataLength
        ? dataString.substring(0, maxDataLength) + '... [truncated]'
        : dataString;

    let mensaje = '';
    let descripcion = '';
    if (errors && errors.length > 0) {
      const ultimoError = errors[errors.length - 1];
      let endpoint = '';
      let requestPayload = '';
      if (
        ultimoError.args &&
        ultimoError.args.length > 1 &&
        typeof ultimoError.args[1] === 'object'
      ) {
        endpoint = ultimoError.args[1].url ? `\nEndpoint: ${ultimoError.args[1].url}` : '';
        if (
          ultimoError.args[1].error &&
          typeof ultimoError.args[1].error === 'object' &&
          ultimoError.args[1].error.body
        ) {
          requestPayload = `\nPayload: ${JSON.stringify(ultimoError.args[1].error.body, null, 2)}`;
        }
        mensaje = ultimoError.args[1].message || 'Error desconocido';
        if (typeof ultimoError.args[1].error === 'string') {
          const preMatch = ultimoError.args[1].error.match(
            /<pre class="exception_value">(.*?)<\/pre>/is,
          );
          if (preMatch && preMatch[1]) {
            descripcion = preMatch[1]
              .replace(/&#x27;/g, "'")
              .replace(/&quot;/g, '"')
              .replace(/&lt;/g, '<')
              .replace(/&gt;/g, '>')
              .replace(/&amp;/g, '&')
              .trim();
            mensaje = descripcion.split('\n')[0] || mensaje;
          } else {
            const titleMatch = ultimoError.args[1].error.match(/<title>(.*?)<\/title>/i);
            descripcion = titleMatch ? titleMatch[1] : ultimoError.args[1].error.substring(0, 200);
          }
        } else {
          descripcion = JSON.stringify(ultimoError.args[1], null, 2);
        }
      } else {
        mensaje = ultimoError.args ? ultimoError.args[0] : 'Error desconocido';
        descripcion = JSON.stringify(ultimoError, null, 2);
      }
      descripcion += endpoint + requestPayload;
    } else {
      mensaje = 'Automatic bug report';
      descripcion = 'No error details available';
    }
    descripcion = this.bugReportPayload.description + '\n\n' + descripcion;

    // Usar FormData para enviar archivos como File
    const formData = new FormData();
    formData.append('title', `Error de usuario - ${this.me?.id} - ${new Date().toISOString()}`);
    formData.append('description', descripcion);
    formData.append('method', 'OTHER');
    formData.append('full_stack_trace', '');
    formData.append('data', safeDataString);
    formData.append('status', 'open');
    formData.append('priority', 'medium');
    formData.append('assigned_to', '');
    formData.append('reporter', this.me?.id);

    // Adjuntar archivos
    if (this.bugReportPayload.screenshots && this.bugReportPayload.screenshots.length > 0) {
      this.bugReportPayload.screenshots.forEach((file: File, idx: number) => {
        formData.append('screenshots', file, file.name);
      });
    }

    this.messageService.clear();
    this.messageService.add({
      severity: 'info',
      summary: 'Enviando reporte',
      detail: 'Por favor, espera...',
    });

    const bugReportPayload: BugReportPayload = {
      title: `Error de usuario - ${this.me?.id} - ${new Date().toISOString()}`,
      description: descripcion,
      data: safeDataString,
      screenshots: this.bugReportPayload.screenshots, // File[]
      status: 'open',
      priority: 'high',
      assigned_to: '',
    };

    this.messageService.clear();
    this.messageService.add({
      severity: 'info',
      summary: 'Enviando reporte',
      detail: 'Por favor, espera...',
    });

    this.bugReportsService.postBugReport(bugReportPayload).subscribe({
      next: () => {
        // Se descarta el aviso de "Enviando reporte" antes de mostrar el resultado:
        // los toasts son sticky, asi que no se iria solo.
        this.messageService.clear();
        this.messageService.add({
          severity: 'success',
          summary: 'Reporte enviado',
          detail: 'Gracias por ayudarnos a mejorar la plataforma.',
        });
      },
      error: () => {
        this.messageService.clear();
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Hubo un problema al enviar el reporte. Por favor, inténtalo de nuevo más tarde.',
        });
      },
    });

    this.bugReportPayload = {
      title: '',
      description: '',
      data: '',
      screenshots: [],
    };
  }

  /**
   * Maneja la selección de archivos para adjuntar capturas al reporte de error.
   * Soporta diferentes formatos de evento (PrimeNG, nativo, etc).
   * @param event Evento de selección de archivos.
   */
  onFileSelected(event: any) {
    // soporta varios shapes de evento: event.target.files, event.files (PrimeNG), event.originalEvent.target.files
    const rawFiles =
      event?.target?.files ??
      event?.files ??
      event?.originalEvent?.target?.files ??
      event?.originalEvent?.dataTransfer?.files ??
      [];

    let filesArray: File[] = [];

    if (rawFiles instanceof FileList) {
      filesArray = Array.from(rawFiles);
    } else if (Array.isArray(rawFiles)) {
      filesArray = rawFiles as File[];
    } else if (rawFiles) {
      // en caso de objeto similar a FileList
      try {
        filesArray = Array.from(rawFiles as any);
      } catch {
        filesArray = [];
      }
    }

    this.bugReportPayload.screenshots = filesArray;
  }

  /**
   * Callback para cerrar la barra lateral de PrimeNG.
   * @param e Evento de cierre.
   */
  closeCallback(e): void {
    this.sidebarRef.close(e);
  }
}
